export enum RouterAliases {
  BASE_VIEW = 'BASE_VIEW',
  DISCOVERY_VIEW = 'DISCOVERY_VIEW',
  SUMMARY_VIEW = 'SUMMARY_VIEW',
  EXPORT_PDF_VIEW = 'EXPORT_PDF_VIEW',
  FLIGHT_EXPLORE_VIEW = 'FLIGHT_EXPLORE_VIEW',
  ACCOMMODATION_EXPLORE_VIEW = 'ACCOMMODATION_EXPLORE_VIEW',
  EXPERIENCE_EXPLORE_VIEW = 'EXPERIENCE_EXPLORE_VIEW',
  DINNING_EXPLORE_VIEW = 'DINNING_EXPLORE_VIEW',
  POI_DETAILS_VIEW = 'POI_DETAILS_VIEW',
  MY_TRIPS_VIEW = 'MY_TRIPS_VIEW',
  AUTH_CALLBACK = 'callback',
  AMEX_LANDING = 'AMEX_LANDING',
  AMEX_LANDING2 = 'AMEX_LANDING2',
  AMEX_PROFILE = 'AMEX_PROFILE',
}

export const RouterPath = {
  [RouterAliases.FLIGHT_EXPLORE_VIEW]: 'FLIGHT',
  [RouterAliases.DINNING_EXPLORE_VIEW]: 'DINING',
  [RouterAliases.EXPERIENCE_EXPLORE_VIEW]: 'EXPERIENCE',
  [RouterAliases.ACCOMMODATION_EXPLORE_VIEW]: 'ACCOMMODATION',
};

export const ActualRoutes = {
  [RouterAliases.SUMMARY_VIEW]: `/summary`,
};
